import { getTotalPointsPossible } from "./getTotalPoints";

export function sortLeaders(leaders, matchups) {
    let leaderArr = Object.values(leaders);
    if (matchups) {
        const newArr = [];
        for (let l of leaderArr) {
            const possiblePoints = getTotalPointsPossible(l.appId, l.matchPoints + l.propPoints + l.bonusPoints + l.propBonus, matchups);
            l.possiblePoints = possiblePoints;
            newArr.push(l);
        }
        leaderArr = newArr;
    }
    const leadersArr = leaderArr.sort((a,b) => {
        
        const aTotal = a.matchPoints + a.propPoints + a.bonusPoints + a.propBonus;
        const bTotal = b.matchPoints + b.propPoints + b.bonusPoints + b.propBonus;
        if (aTotal < bTotal) {
            return 1;
        } else if (aTotal === bTotal) {
            if (a.possiblePoints && a.possiblePoints < b.possiblePoints) {
                return 1
            } else {
                const aCorrect = a.matchCorrect + a.propCorrect;
                const bCorrect = b.matchCorrect + b.propCorrect;
                if (aCorrect < bCorrect ) {
                    return 1
                }
            }
        }
        return -1
    })

    return leadersArr;
}